import { faBagShopping } from '@fortawesome/pro-regular-svg-icons'
import { ItListItem, ProductItem, ProductItemInput } from 'types/graphql'

import ProductPlaceholder from 'src/assets/image/PlaceholderProductSVG'

import { ItemDescription } from '..'

import Builder from './Builder'
import Header from './Header'

export const itemDescription: ItemDescription<ProductItem, ProductItemInput> = {
  hasCustomFields: true,
  type: 'product',
  icon: faBagShopping,
  label: 'Product',
  thumbnail: (item: ItListItem) => item.product.coverUrl,
  Placeholder: () => <ProductPlaceholder />,
  generateEmptyItemDetails() {
    return {
      coverUrl: '',
      amazonUrl: '',
      promoCodeCode: '',
      promoCodeDiscount: '',
      promoCodeValidFrom: null,
      promoCodeValidTo: null,
    }
  },
  convertToGQLInput({
    amazonUrl,
    coverUrl,
    id,
    promoCodeCode,
    promoCodeDiscount,
    promoCodeValidFrom,
    promoCodeValidTo,
  }: ProductItem): ProductItemInput {
    return {
      amazonUrl,
      hasCover: !!coverUrl,
      id,
      promoCodeCode,
      promoCodeDiscount,
      promoCodeValidFrom,
      promoCodeValidTo,
    }
  },
  Header,
  Builder,
}
